export default __webpack_public_path__ + "static/media/@brilliant.0aff1725.svg";